import { render, staticRenderFns } from "./ProductOrderModal.vue?vue&type=template&id=145ba95e&"
import script from "./ProductOrderModal.vue?vue&type=script&lang=js&"
export * from "./ProductOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports